import React from 'react';
import './PullToRefreshIndicator.css';

/**
 * Компонент индикатора pull-to-refresh
 */
export default function PullToRefreshIndicator({ 
  isRefreshing, 
  isPulling, 
  progress, 
  canRefresh,
  pullDistance = 0
}) {
  const shouldShowRefreshIndicator = isPulling || isRefreshing;
  
  // Вычисляем высоту индикатора на основе расстояния потягивания
  const indicatorHeight = Math.min(pullDistance * 0.5, 80); // Максимум 80px
  
  // Показываем индикатор, если есть потягивание или обновление
  if (!shouldShowRefreshIndicator && pullDistance === 0) {
    return null;
  }

  return (
    <div 
      className="pull-to-refresh-indicator"
      style={{ 
        height: `${indicatorHeight}px`,
        opacity: shouldShowRefreshIndicator ? 1 : Math.min(progress, 1)
      }}
    >
      <div className="pull-to-refresh-content">
        {isRefreshing ? (
          <>
            <div className="refresh-spinner" />
            <span className="refresh-text">Обновление...</span>
          </>
        ) : (
          <>
            <div 
              className={`refresh-arrow ${canRefresh ? 'can-refresh' : ''}`}
              style={{ 
                transform: `rotate(${progress * 180}deg)`,
                opacity: progress 
              }}
            >
              ↑
            </div>
            <span className="refresh-text">
              {canRefresh ? 'Отпустите для обновления' : 'Потяните для обновления'}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
